import { Modal, Button, Form, Col, Row } from 'react-bootstrap';
import React from "react";
import { useEffect, useState, useRef } from 'react';

const ReusableModal = (props) => {
    const { size, show, handleClose, handleSubmit, title, children, bgColor, showSave = true, isSubmitting = false } = props;

    // ryan d - custom popup modal that can be used widley across other forms 
    return (
        <Modal size={size} show={show} onHide={handleClose} className="fpModal flowin">
            <Modal.Header closeButton style={{ backgroundColor: '#00384B', color: '#fff', borderBottom: 'none'}}>
                <div className="fpModal-title">{title}</div>
            </Modal.Header>
            <div className="fpModal-body">
                <Modal.Body style={bgColor ? { backgroundColor: bgColor } : null} >
                    <Form>
                        {children}
                    </Form>
                </Modal.Body>
                <Modal.Footer style={bgColor ? { backgroundColor: bgColor } : null}>
                    {showSave &&
                        <>
                        <Row>
                            <Col md="9" xs="12">
                                <p><b>Note: </b>By selecting "SUBMIT", you confirm that you consent to your Personal Data being processed by FP McCann</p>
                            </Col>
                            <Col md="3" xs="12">
                                <Button type="submit" onClick={handleSubmit} className="btn" disabled={isSubmitting}>
                                    {props.submitButtonText}
                                </Button>
                            </Col>
                        </Row>

                    </>
                    }
                </Modal.Footer>
            </div>
        </Modal>
    );
};

export default ReusableModal;
